import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  {
    label: 'Licensed & Insured',
    sublabel: 'Credentials',
    value: 'TX Licensed Contractor',
  },
  {
    label: 'Rockport · Corpus Christi · The Coastal Bend',
    sublabel: 'Service Area',
    value: null,
  },
  {
    label: 'On Every Project',
    sublabel: 'Always',
    value: 'Free Estimates',
  },
];

export default function StatsBar() {
  return (
    <section className="py-20 md:py-24 bg-[#111111] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-white/10">
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="flex flex-col items-center text-center px-8 md:px-12 py-10 md:py-0"
            >
              <span className="font-body text-[#C97B2E] text-xs font-bold uppercase tracking-[0.3em] mb-3 block">
                {stat.sublabel}
              </span>
              {stat.value && (
                <p className="font-heading text-white text-2xl md:text-3xl font-bold mb-2">
                  {stat.value}
                </p>
              )}
              <p className={`font-body text-white/55 text-sm leading-relaxed ${!stat.value ? 'font-heading text-white text-xl md:text-2xl font-bold text-white/80' : ''}`}>
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}